import { Iap, ProductRewardType } from '.';

export function claimProductRewards(
  state: Iap.MutableState,
  rewards: Partial<Record<ProductRewardType, number>>,
) {
  const { Inventory } = Iap.$DEPENDENCIES;
  if (rewards.paidGems) {
    Inventory.modifiers(state).addPaidGems(rewards.paidGems);
  }
  if (rewards.freeGems) {
    Inventory.modifiers(state).addFreeGems(rewards.freeGems);
  }
}
